import { render, staticRenderFns } from "./AccountCandidateDetail.vue?vue&type=template&id=0696f550"
import script from "./AccountCandidateDetail.vue?vue&type=script&lang=js"
export * from "./AccountCandidateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports